import API from '../../../../commons/api/api';
import * as actionTypes from '../actions/type';
import moment from 'moment';

export const initialState = {
  awards: [],
  params: [],
  award: {},
  entries: [],
  entries_params: {},
  entry: {},
  isProcessing: false,

  isLoadingForm: false,
  registerFailed: null,

  votingFailed: null,

  deleteEntryFailed: null,

  voted: true,
};

const characterReducers = (state  = initialState, action) => {
  const { payload } = action;
  switch (action.type) {

    case actionTypes.GET_AWARD:
      return { 
        ...state, 
        isProcessing: true, 
        type: action.type 
      };
    case actionTypes.GET_AWARD_SUCCESS:
      return {
        ...state,
        isProcessing: false,
        award: payload.award,
        entries: payload.entries,
      };

    case actionTypes.GET_AWARDS:
      return { 
        ...state, 
        isProcessing: true, 
        type: action.type 
      };
    case actionTypes.GET_AWARDS_SUCCESS:
      let awards = payload.data
      if (payload.current_page > 1) {
        awards = [...state.awards, ...awards]
      }
      return {
        ...state,
        isProcessing: false,
        awards: awards,
        params: payload,
      };

    case actionTypes.GET_MY_AWARD_ENTRY:
      return { 
        ...state, 
        isProcessing: true, 
        type: action.type 
      };
    case actionTypes.GET_MY_AWARD_ENTRY_SUCCESS:
      return {
        ...state,
        isProcessing: false,
        entry: payload,
      };

    case actionTypes.GET_AWARD_ENTRY:
      return { 
        ...state, 
        isProcessing: true, 
        type: action.type 
      };
    case actionTypes.GET_AWARD_ENTRY_SUCCESS:
      if (!payload) {
        return {...state}
      }
      let entries = payload.data
      if (
        payload.current_page > 1
        || (state.entries_params.per_page && payload.per_page > state.entries_params.per_page)
      ) {
        entries = [...state.entries, ...entries]
      }
      return {
        ...state,
        isProcessing: false,
        entries,
        entries_params: payload,
      };

    case actionTypes.REGISTER_AWARD:
      return { 
        ...state, 
        isLoadingForm: true, 
        registerFailed: null,
        type: action.type 
      };
    case actionTypes.REGISTER_AWARD_SUCCESS:
      return {
        ...state,
        isLoadingForm: false,
        registerFailed: null,
        type: action.type 
      };
    case actionTypes.REGISTER_AWARD_FAILED:
      return {
        ...state,
        isLoadingForm: false,
        type: action.type,
        registerFailed: payload
      };

    case actionTypes.VOTING_AWARD:
      return { 
        ...state, 
        isLoadingForm: true, 
        votingFailed: null,
        type: action.type 
      };
    case actionTypes.VOTING_AWARD_SUCCESS:
      return {
        ...state,
        isLoadingForm: false,
        votingFailed: null,
        type: action.type 
      };
    case actionTypes.VOTING_AWARD_FAILED:
      return {
        ...state,
        isLoadingForm: false,
        type: action.type,
        votingFailed: payload
      };

    case actionTypes.CHECK_VOTED:
      return { 
        ...state, 
        voted: true,
        type: action.type 
      };
    case actionTypes.CHECK_VOTED_SUCCESS:
      return {
        ...state,
        voted: payload,
        type: action.type 
      };
    case actionTypes.CHECK_VOTED_FAILED:
      return { 
        ...state, 
        voted: false,
        type: action.type 
      };

    case actionTypes.DELETE_AWARD_ENTRY:
      return { 
        ...state, 
        isLoadingForm: true,
        type: action.type 
      };
    case actionTypes.DELETE_AWARD_ENTRY_SUCCESS:
      return {
        ...state,
        isLoadingForm: false,
        entry: {...state.entry, deleted_at: moment().format('Y-MM-DD h:m:s')},
        type: action.type 
      };
    case actionTypes.DELETE_AWARD_ENTRY_FAILED:
      return {
        ...state, 
        isLoadingForm: false,
        type: action.type 
      };
      
    case actionTypes.RESET_FORM_REGISTER:
      return {
        ...state, 
        isLoadingForm: false,
        registerFailed: null,
        type: action.type 
      };

    default:
      return state;
  }
};

export default characterReducers;
